import styled from 'styled-components';

export const MainContainer = styled.div`
  margin: 32px 0px;
`;

export const Header = styled.span`
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
  color: #101828;
`;